"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestRackRelaysValidation = void 0;
class TestRackRelaysValidation {
    static isValid(entity) {
        // Validate entity.ST1_closed for existence and correct type.
        if (entity.ST1_closed == undefined)
            return false;
        if (typeof entity.ST1_closed !== "boolean")
            return false;
        // Validate entity.ST2_closed for existence and correct type.
        if (entity.ST2_closed == undefined)
            return false;
        if (typeof entity.ST2_closed !== "boolean")
            return false;
        // Validate entity.ST3_closed for existence and correct type.
        if (entity.ST3_closed == undefined)
            return false;
        if (typeof entity.ST3_closed !== "boolean")
            return false;
        // Validate entity.ST6_closed for existence and correct type.
        if (entity.ST6_closed == undefined)
            return false;
        if (typeof entity.ST6_closed !== "boolean")
            return false;
        return true;
    }
}
exports.TestRackRelaysValidation = TestRackRelaysValidation;
